<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nHkibf/tc-custom/9781488070020.jpg?1740799899278" alt="This image is the cover for the book Last Man She Expected, Welcome to Starlight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Man She Expected, Welcome to Starlight
      </h1>
      <p class="bookDescription body article font2">
        <b>The town of Starlight can make being so wrong feel so right. Second in the series from the <i>USA Today</i>–bestselling author of <i>The Best Intentions</i>.</b><br/><br/>Falling for her arch nemesis . . . isn’t going to happen.<br/><br/>Moving to Starlight was Mara Reed’s first step forward after her devastating divorce. But had she known she’d find Parker Johnson, her ex-husband’s ruthless divorce attorney, there, she might have gone in a different direction. Away from the big city, Mara is seeing Parker in a new light—but is it enough for her to set aside her anger?<br/><br/>From Harlequin Special Edition: Believe in love. Overcome obstacles. Find happiness.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Major
      </h2>
      
      <p class="authorDescription body article">USA Today bestselling author Michelle Major loves stories of new beginnings, second chances and always a happily ever after. An avid hiker and avoider of housework, she lives in the shadow of the Rocky Mountains with her husband, two teenagers and a menagerie of spoiled furbabies. Connect with her at www.michellemajor.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02d2e4a7